/**
 * Drawer component overrides.
 * Glassmorphism drawer with backdrop blur.
 */

import type { Theme } from '@mui/material/styles';
import type { Skin } from '../../@core/types';

const drawer = (skin: Skin): Theme['components'] => ({
  MuiDrawer: {
    defaultProps: {
      ...(skin === 'bordered' && {
        PaperProps: {
          elevation: 0,
        },
      }),
    },
    styleOverrides: {
      paper: {
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderColor: 'var(--glass-border)',
        ...(skin !== 'bordered' && {
          boxShadow: 'var(--mui-customShadows-xl)',
        }),
      },
    },
  },
});

export default drawer;
